var map = {
	"./365-fa-logo-extended.svg": 3215,
	"./365-logo-brand.svg": 3216,
	"./365-logo-extended.svg": 2625,
	"./365-logo.svg": 2626,
	"./CaretRight.svg": 3217,
	"./arrow-right.svg": 486,
	"./calculator-arrow.svg": 1527,
	"./caret-left-circle-outline.svg": 3218,
	"./caret-left-circle.svg": 1535,
	"./caret-right-circle-outline.svg": 3219,
	"./caret-right-circle.svg": 1536,
	"./caret-right.svg": 492,
	"./carret-down-flashcards.svg": 2342,
	"./carret-down.svg": 2335,
	"./certificate-badge.svg": 1802,
	"./check.svg": 3220,
	"./checkout-minus-icon.svg": 1756,
	"./checkout-plus-icon.svg": 1757,
	"./close-icon.svg": 667,
	"./companies/logo-alphabet.svg": 1140,
	"./companies/logo-amazon-2.svg": 1141,
	"./companies/logo-amazon.svg": 1142,
	"./companies/logo-azercell.svg": 1143,
	"./companies/logo-bank-of-america.svg": 1144,
	"./companies/logo-barclays.svg": 1145,
	"./companies/logo-bbc.svg": 1146,
	"./companies/logo-bnp-paribas.svg": 1147,
	"./companies/logo-booking.svg": 1148,
	"./companies/logo-citibank.svg": 1149,
	"./companies/logo-coca-cola-auto.svg": 1150,
	"./companies/logo-coca-cola-white.svg": 1537,
	"./companies/logo-coca-cola.svg": 1151,
	"./companies/logo-deloitte.svg": 1152,
	"./companies/logo-experian.svg": 1153,
	"./companies/logo-facebook.svg": 1154,
	"./companies/logo-g.svg": 1538,
	"./companies/logo-goldman-sachs-new.svg": 1155,
	"./companies/logo-goldman-sachs.svg": 1539,
	"./companies/logo-google-new.svg": 1156,
	"./companies/logo-google.svg": 1157,
	"./companies/logo-h.svg": 1158,
	"./companies/logo-henkel.svg": 1159,
	"./companies/logo-hsbc-new.svg": 1160,
	"./companies/logo-hsbc.svg": 1540,
	"./companies/logo-ikea-new.svg": 1161,
	"./companies/logo-ikea.svg": 1541,
	"./companies/logo-infineon.svg": 1162,
	"./companies/logo-instagram.svg": 1163,
	"./companies/logo-jp-morgan.svg": 1164,
	"./companies/logo-jti.svg": 1165,
	"./companies/logo-linkedin.svg": 1166,
	"./companies/logo-meta-new.svg": 1167,
	"./companies/logo-meta.svg": 1542,
	"./companies/logo-morgan-stanley-new.svg": 1168,
	"./companies/logo-morgan-stanley.svg": 1543,
	"./companies/logo-netflix.svg": 1544,
	"./companies/logo-oracle.svg": 1169,
	"./companies/logo-paypal.svg": 1170,
	"./companies/logo-pwc-new.svg": 1171,
	"./companies/logo-pwc.svg": 1545,
	"./companies/logo-spotify.svg": 1546,
	"./companies/logo-tesla.svg": 1172,
	"./companies/logo-visa.svg": 1173,
	"./companies/logo-walmart.svg": 1174,
	"./companies/logo-youtube.svg": 1175,
	"./courses/arrow-right.svg": 3221,
	"./courses/clock-colored.svg": 1596,
	"./courses/clock.svg": 2324,
	"./courses/fire.svg": 3222,
	"./courses/medal-colored.svg": 2332,
	"./courses/medal.svg": 1668,
	"./courses/monitor-colored.svg": 2330,
	"./courses/monitor.svg": 1561,
	"./courses/play-circle.svg": 3223,
	"./courses/play.svg": 3224,
	"./courses/practical-tasks-colored.svg": 2331,
	"./courses/practical-tasks.svg": 3225,
	"./courses/replay.svg": 3226,
	"./curved-arrow.svg": 1510,
	"./editor/bold.svg": 3227,
	"./editor/emoji.svg": 3228,
	"./editor/image.svg": 3229,
	"./editor/italic.svg": 3230,
	"./editor/link.svg": 3231,
	"./editor/underline.svg": 3232,
	"./exams/arrow.svg": 2095,
	"./exams/correct-answer.svg": 2039,
	"./exams/excel.svg": 2319,
	"./exams/icon-star.svg": 2320,
	"./exams/incorrect-answer.svg": 2040,
	"./exams/pdf.svg": 2321,
	"./exams/python.svg": 2322,
	"./eye-closed.svg": 3233,
	"./eye-opened.svg": 3234,
	"./eye.svg": 2387,
	"./fa/fa-icon-checked-blue.svg": 3235,
	"./flashcards/browse-deck.svg": 2047,
	"./flashcards/click-hand.svg": 2390,
	"./flashcards/load-arrow.svg": 2048,
	"./flashcards/reload-deck.svg": 2046,
	"./flashcards/restart-review.svg": 3236,
	"./flashcards/review-small-eye.svg": 2341,
	"./flashcards/send-result.svg": 2340,
	"./flashcards/take-test.svg": 2049,
	"./flashcards/white-left-arrow.svg": 2392,
	"./gfx-certificate-circle.svg": 3237,
	"./gfx-certificate-excel.svg": 3238,
	"./gfx-certificate-git.svg": 3239,
	"./gfx-certificate-powerbi.svg": 3240,
	"./gfx-certificate-python.svg": 3241,
	"./gfx-certificate-r.svg": 3242,
	"./gfx-certificate-tableau.svg": 3243,
	"./gfx-certificate-theory.svg": 3244,
	"./gfx-hats-left.svg": 3245,
	"./gfx-hats-right.svg": 3246,
	"./icon-404-lms-courses.svg": 3247,
	"./icon-404-lms-practice.svg": 3248,
	"./icon-404-lms-qa.svg": 3249,
	"./icon-arrow-back.svg": 522,
	"./icon-arrow-blue.svg": 3250,
	"./icon-arrow-dropdown.svg": 2334,
	"./icon-arrow-expand.svg": 1637,
	"./icon-arrow-left.svg": 1659,
	"./icon-arrow-next.svg": 2394,
	"./icon-arrow-prev.svg": 2395,
	"./icon-arrow-right.svg": 1634,
	"./icon-arrow-up.svg": 2122,
	"./icon-arrow.svg": 1629,
	"./icon-assignment.svg": 3251,
	"./icon-audience-1.svg": 2351,
	"./icon-audience-2.svg": 2352,
	"./icon-audience-3.svg": 2353,
	"./icon-back.svg": 2151,
	"./icon-black-filled-arrow.svg": 3252,
	"./icon-bulb.svg": 3253,
	"./icon-career-track.svg": 2325,
	"./icon-certificate.svg": 2349,
	"./icon-certificates.svg": 3254,
	"./icon-check-blue-bold.svg": 3255,
	"./icon-check-circle.svg": 1597,
	"./icon-check-extreme-fucsia.svg": 3256,
	"./icon-check-list.svg": 3257,
	"./icon-check-projects.svg": 1704,
	"./icon-check.svg": 2333,
	"./icon-checkbox.svg": 3258,
	"./icon-checked-accent-light-3.svg": 3259,
	"./icon-checked-bf.svg": 3260,
	"./icon-checked-blue.svg": 3261,
	"./icon-checked-cm.svg": 3262,
	"./icon-checked-ds-accent.svg": 3263,
	"./icon-checked-extreme-blue-2.svg": 3264,
	"./icon-checked-mw.svg": 3265,
	"./icon-checked-purple.svg": 3266,
	"./icon-checked-tyf.svg": 3267,
	"./icon-checked-yellow-bold.svg": 3268,
	"./icon-checked-yellow.svg": 3269,
	"./icon-checked.svg": 3270,
	"./icon-circle-check.svg": 3271,
	"./icon-clear-filters.svg": 3272,
	"./icon-clock-colored.svg": 3273,
	"./icon-clock.svg": 2347,
	"./icon-close.svg": 485,
	"./icon-code.svg": 3274,
	"./icon-colored-google.svg": 3275,
	"./icon-colored-linkedin-fill.svg": 3276,
	"./icon-comment.svg": 1705,
	"./icon-complete-program.svg": 3277,
	"./icon-completed.svg": 3278,
	"./icon-copy-text.svg": 3279,
	"./icon-copy.svg": 2055,
	"./icon-course-banner.svg": 2121,
	"./icon-courses.svg": 3280,
	"./icon-difficulty-advanced-2.svg": 2098,
	"./icon-difficulty-advanced.svg": 2343,
	"./icon-difficulty-beginner-2.svg": 2099,
	"./icon-difficulty-beginner.svg": 2344,
	"./icon-difficulty-intermediate-2.svg": 2100,
	"./icon-difficulty-intermediate.svg": 2345,
	"./icon-down-arrow.svg": 2359,
	"./icon-download-arrow.svg": 3281,
	"./icon-download.svg": 3282,
	"./icon-download2.svg": 3283,
	"./icon-editor-bold.svg": 3284,
	"./icon-editor-code.svg": 3285,
	"./icon-editor-codeblock.svg": 3286,
	"./icon-editor-emoji.svg": 3287,
	"./icon-editor-image.svg": 3288,
	"./icon-editor-italic.svg": 3289,
	"./icon-editor-link.svg": 3290,
	"./icon-editor-strike.svg": 3291,
	"./icon-exam-clock.svg": 2043,
	"./icon-exam-download.svg": 3292,
	"./icon-exam-flag.svg": 2041,
	"./icon-exam-question.svg": 2323,
	"./icon-exam-share-result.svg": 3293,
	"./icon-exam-warning.svg": 1231,
	"./icon-exams-subtract.svg": 2329,
	"./icon-exclamation.svg": 3294,
	"./icon-exit.svg": 3295,
	"./icon-facebook-white.svg": 3296,
	"./icon-facebook.svg": 3297,
	"./icon-faq-expand.svg": 1027,
	"./icon-fb.svg": 2056,
	"./icon-filter-sort.svg": 2085,
	"./icon-filter.svg": 2083,
	"./icon-flashcards-arrow.svg": 2391,
	"./icon-header-back-arrow.svg": 3298,
	"./icon-help.svg": 3299,
	"./icon-home.svg": 3300,
	"./icon-info.svg": 525,
	"./icon-inlinecode.svg": 3301,
	"./icon-language.svg": 2348,
	"./icon-learn.svg": 2326,
	"./icon-library-badge-advanced.svg": 1853,
	"./icon-library-badge-beginner.svg": 1854,
	"./icon-library-badge-intermediate.svg": 1855,
	"./icon-link.svg": 3302,
	"./icon-linkedin-white.svg": 3303,
	"./icon-linkedin.svg": 2057,
	"./icon-locked.svg": 2079,
	"./icon-mail.svg": 489,
	"./icon-menu-arrow.svg": 3304,
	"./icon-menu-collapse.svg": 3305,
	"./icon-mobile-filter.svg": 3306,
	"./icon-newsfeed-comment.svg": 3307,
	"./icon-newsfeed-edit.svg": 3308,
	"./icon-newsfeed-learners.svg": 3309,
	"./icon-newsfeed-like.svg": 3310,
	"./icon-newsfeed-remove.svg": 3311,
	"./icon-newsfeed-report.svg": 3312,
	"./icon-newsfeed-snooze.svg": 3313,
	"./icon-newsfeed-trophy.svg": 3314,
	"./icon-notifications-bell.svg": 3315,
	"./icon-photo.svg": 3316,
	"./icon-pin.svg": 1341,
	"./icon-play-active.svg": 3317,
	"./icon-play.svg": 2337,
	"./icon-practice.svg": 3318,
	"./icon-price.svg": 2350,
	"./icon-pricing-arrow-down.svg": 2143,
	"./icon-pricing-badge.svg": 2142,
	"./icon-pricing-check.svg": 2146,
	"./icon-project-content.svg": 2355,
	"./icon-project-featured.svg": 2356,
	"./icon-project-files.svg": 2101,
	"./icon-project-related-courses.svg": 2358,
	"./icon-project-solution-files.svg": 2354,
	"./icon-project-topics.svg": 2357,
	"./icon-project.svg": 3319,
	"./icon-qa-ask.svg": 3320,
	"./icon-qa-delete-answer.svg": 3321,
	"./icon-qa-diamond.svg": 3322,
	"./icon-qa-edit-answer.svg": 3323,
	"./icon-qa-ellipsis-v.svg": 2364,
	"./icon-qa-follow.svg": 2362,
	"./icon-qa-followed.svg": 3324,
	"./icon-qa-glasses.svg": 3325,
	"./icon-qa-magnifier.svg": 3326,
	"./icon-qa-mark.svg": 2361,
	"./icon-qa-report.svg": 3327,
	"./icon-qa-resolve.svg": 2360,
	"./icon-qa-unassign.svg": 2363,
	"./icon-qa.svg": 3328,
	"./icon-question.svg": 1042,
	"./icon-quiz.svg": 3329,
	"./icon-quote-testimonials.svg": 1184,
	"./icon-quote.svg": 2346,
	"./icon-rating-star.svg": 3330,
	"./icon-remaining-time.svg": 3331,
	"./icon-replay.svg": 3332,
	"./icon-reset.svg": 2389,
	"./icon-resources.svg": 3333,
	"./icon-scroll-top.svg": 3334,
	"./icon-search-assignment.svg": 3335,
	"./icon-search-certificate.svg": 3336,
	"./icon-search-code.svg": 3337,
	"./icon-search-course-notes.svg": 3338,
	"./icon-search-course.svg": 3339,
	"./icon-search-dataset.svg": 3340,
	"./icon-search-lesson.svg": 3341,
	"./icon-search-progress-0.svg": 3342,
	"./icon-search-progress-1.svg": 3343,
	"./icon-search-progress-2.svg": 3344,
	"./icon-search-project.svg": 3345,
	"./icon-search-questions.svg": 3346,
	"./icon-search-quiz.svg": 3347,
	"./icon-search-resource.svg": 3348,
	"./icon-search-time.svg": 3349,
	"./icon-search.svg": 1126,
	"./icon-share-score.svg": 3350,
	"./icon-share.svg": 2365,
	"./icon-share2.svg": 3351,
	"./icon-shield.svg": 3352,
	"./icon-shuffle.svg": 2388,
	"./icon-site-linkedin.svg": 1574,
	"./icon-site-search.svg": 3353,
	"./icon-site-twitter.svg": 3354,
	"./icon-snooze.svg": 3355,
	"./icon-sort.svg": 2084,
	"./icon-star.svg": 3356,
	"./icon-stock-down.svg": 3357,
	"./icon-stock-up.svg": 3358,
	"./icon-subtract-unlocked.svg": 3359,
	"./icon-subtract.svg": 3360,
	"./icon-sync.svg": 2088,
	"./icon-tinymce-bold.svg": 3361,
	"./icon-tinymce-code.svg": 3362,
	"./icon-tinymce-codeblock.svg": 3363,
	"./icon-tinymce-emoji.svg": 3364,
	"./icon-tinymce-italic.svg": 3365,
	"./icon-tinymce-link.svg": 3366,
	"./icon-tinymce-strike.svg": 3367,
	"./icon-tinymce-submit.svg": 3368,
	"./icon-trash.svg": 2086,
	"./icon-trustpilot.svg": 1862,
	"./icon-twitter.svg": 2058,
	"./icon-up-arrow.svg": 1653,
	"./icon-vertical-dots.svg": 3369,
	"./icon-video-cc.svg": 3370,
	"./icon-video-full-screen.svg": 3371,
	"./icon-video-mute.svg": 3372,
	"./icon-video-pause.svg": 3373,
	"./icon-video-play.svg": 2336,
	"./icon-video-rewind.svg": 3374,
	"./icon-video-settings.svg": 3375,
	"./icon-video-transcript.svg": 3376,
	"./icon-video-volume.svg": 3377,
	"./icon-warning.svg": 3378,
	"./icon-x.svg": 3379,
	"./icon-youtube.svg": 3380,
	"./linkedin-logo.svg": 3381,
	"./medal.svg": 1631,
	"./minus-icon.svg": 2396,
	"./player/cc.svg": 3382,
	"./player/fullscreen.svg": 3383,
	"./player/mute.svg": 3384,
	"./player/pause.svg": 3385,
	"./player/play-v2.svg": 3386,
	"./player/play.svg": 3387,
	"./player/polygon.svg": 3388,
	"./player/rewind.svg": 3389,
	"./player/settings.svg": 3390,
	"./player/volume.svg": 3391,
	"./plus-icon.svg": 2397,
	"./projects-guided-unguided.svg": 3392,
	"./projects-instruction.svg": 3393,
	"./projects-quiz.svg": 3394,
	"./rounded-quotes-big.svg": 2338,
	"./rounded-quotes.svg": 3395,
	"./select-arrow.svg": 3396,
	"./select-dropdown-arrow.svg": 3397,
	"./signatures/company-linkedin.svg": 2327,
	"./signatures/company-youtube.svg": 2328,
	"./sql.svg": 3398,
	"./tech-excel.svg": 3399,
	"./tech-git.svg": 3400,
	"./tech-google-sheets.svg": 3401,
	"./tech-powerbi.svg": 3402,
	"./tech-python (2).svg": 3403,
	"./tech-python.svg": 3404,
	"./tech-r.svg": 3405,
	"./tech-responsive-artificial-intelligence.svg": 533,
	"./tech-responsive-chatgpt.svg": 695,
	"./tech-responsive-data.svg": 696,
	"./tech-responsive-excel.svg": 697,
	"./tech-responsive-git.svg": 698,
	"./tech-responsive-google-sheets.svg": 699,
	"./tech-responsive-jupyter.svg": 700,
	"./tech-responsive-langchain.svg": 701,
	"./tech-responsive-multiple.svg": 702,
	"./tech-responsive-powerbi.svg": 703,
	"./tech-responsive-powerpoint.svg": 704,
	"./tech-responsive-python.svg": 705,
	"./tech-responsive-r.svg": 706,
	"./tech-responsive-sql.svg": 707,
	"./tech-responsive-tableau.svg": 708,
	"./tech-responsive-theory.svg": 709,
	"./tech-sql.svg": 3406,
	"./tech-tableau.svg": 3407,
	"./tech-theory.svg": 3408,
	"./tightly-arrow.svg": 3409,
	"./topic-responsive-business analytics.svg": 3410,
	"./topic-responsive-business-analytics.svg": 3411,
	"./topic-responsive-career-development.svg": 3412,
	"./topic-responsive-data-analysis.svg": 3413,
	"./topic-responsive-data-processing.svg": 3414,
	"./topic-responsive-data-science.svg": 3415,
	"./topic-responsive-data-visualization.svg": 3416,
	"./topic-responsive-deep-learning.svg": 3417,
	"./topic-responsive-financial-analysis.svg": 3418,
	"./topic-responsive-machine-learning.svg": 3419,
	"./topic-responsive-mathematics.svg": 3420,
	"./topic-responsive-programming.svg": 3421,
	"./vector.svg": 3422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3214;